import './index.scss';
import React from 'react';
import { Outlet } from "react-router-dom";

const PublicLayout = ({ ...props }) => {
  return (
    <div className="public-page-wrapper">
        <div className='public-page-content'>
          <Outlet />
        </div>
    </div>
  );
};

export default PublicLayout;